module.exports = __webpack_public_path__ + "img/135-belarus.0e11c235.svg";